import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import IconArrow from './IconArrow';
import Airtable from 'airtable';
import { avatarData } from '../data/avatarData';

function ShareButton( { avatar, participant, dispatch } ) {
  // Set up the state
  const [ thinking, setThinking ] = useState( false );
  const [ redirect, setRedirect ] = useState( false );
  const [ redirectText, setRedirectText ] = useState( false );
  const [ redirectPath, setRedirectPath ] = useState( null );

  // Save a few necessary vars
  const base = new Airtable( { apiKey: `${process.env.REACT_APP_AIRTABLE_API_KEY}` } ).base( 'appJ4XWmflOm4QY2P' );
  const currentAvatar = avatar[ avatar.currentAvatar ];
  const currentAvatarIndex = avatarData.findIndex( data => data.prefix === avatar.currentAvatar );


  useEffect( () => {
    // Set up the redirect depending on if we are on the last avatar or not.
    if ( currentAvatarIndex === avatarData.length - 1 ) {
      setRedirectText( 'Wrap up' );
      setRedirectPath( '/thank-you' );
    } else {
      setRedirectText( `Build next avatar` );
      setRedirectPath( `/${avatarData[ currentAvatarIndex + 1 ].name}-${avatarData[ currentAvatarIndex + 1 ].options[ 0 ].id}` );
    }
  }, [ currentAvatarIndex ] );

  // Set up what happens when we click on the button
  let clickHandler = () => {

    // We will be thinking for a little while...
    setThinking( true );

    // Push the avatar we have just made up to Airtable
    base( 'User responses' ).create( [
      {
        'fields': {
          'posting_date': new Date(),
          'prefix': avatar.currentAvatar,
          ...currentAvatar,
          ...participant
        }
      },
    ], function ( err, records ) {
      if ( err ) {
        // If there is an error log the error but move on regardless
        console.error( err );
      } else {
        // If there are records then save the record id to our saved ids
        records.forEach( function ( record ) {
          console.log( 'New record added: ' + record.getId() );
          dispatch( {
            type: 'ADD_ID',
            id: record.getId(),
          } );
        } );
      }

      // Once we are done...

      // Stop thinking...
      setThinking( false );

      // Redirect the page...
      setRedirect( true );

      // Update the current avatar in the redux store...
      if ( currentAvatarIndex !== avatarData.length - 1 ) {
        dispatch( {
          type: 'SET_AVATAR',
          currentAvatar: avatarData[ currentAvatarIndex + 1 ].prefix,
        } );
      }

    } );
  };

  if ( redirect ) {
    return <Redirect to={redirectPath}/>;
  }

  return (
    <button
      onClick={() => clickHandler()}
      className={`text button-icon ${thinking && 'disabled'}`} disabled={thinking}>{redirectText}<IconArrow/>
    </button>
  )
}

function mapStateToProps( state ) {
  return {
    avatar: state.avatar,
    participant: state.participant
  };
}

export default connect( mapStateToProps )( ShareButton );
